import type { Sx } from '@/shared/types/uiTypes';

import { GX_MAIN_BACKGROUND, GX_TILE_LIGHT } from '@/config/colors';

export const DARK_GRADIENT_BACKGROUND =
  `linear-gradient(244deg, ${GX_TILE_LIGHT} 0%, ${GX_MAIN_BACKGROUND} 99.27%) !important` as const;

/**
 * Base container styles for layouts with dark gradient background
 */
export const darkGradientContainerSx: Sx = {
  backgroundImage: DARK_GRADIENT_BACKGROUND,
  width: 'fit-content',
  minWidth: '100%'
};

/**
 * Common content wrapper styles for centered layouts
 */
export const centeredContentWrapperSx: Sx = {
  minHeight: '100vh',
  height: '100%',
  minWidth: '300px',
  display: 'flex',
  justifyContent: 'center'
};
